import SettingsIcon from '@mui/icons-material/Settings';
import { SettingList } from './Setting.List';
import { SettingCreate } from './Setting.Create';
import { SettingEdit } from './Setting.Edit';

export default {
    list: SettingList,
    create: SettingCreate,
    edit: SettingEdit,
    icon: SettingsIcon,
};
